/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_Li3_DescInputs */

const tr_iade_iptal_s7_li3_desc = /** @type {(inputs: Iade_Iptal_S7_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni dönem bedeli ödeme öncesinde gösterilir; Abone kabul etmezse ödeme yapmaz ve abonelik süre sonunda sona erer.`)
};

const en_iade_iptal_s7_li3_desc = /** @type {(inputs: Iade_Iptal_S7_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The price of the new term is shown before payment; if the Subscriber does not accept it, no payment is made and the subscription ends at the end of the term.`)
};

const de_iade_iptal_s7_li3_desc = /** @type {(inputs: Iade_Iptal_S7_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Preis der neuen Laufzeit wird vor der Zahlung angezeigt; lehnt der Abonnent ihn ab, zahlt er nicht, und das Abonnement endet mit der Laufzeit.`)
};

const ru_iade_iptal_s7_li3_desc = /** @type {(inputs: Iade_Iptal_S7_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость нового срока показывается до оплаты; если Абонент с ней не согласен, он не оплачивает, и подписка прекращается по окончании срока.`)
};

/**
* | output |
* | --- |
* | "The price of the new term is shown before payment; if the Subscriber does not accept it, no payment is made and the subscription ends at the end of the term." |
*
* @param {Iade_Iptal_S7_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_li3_desc = /** @type {((inputs?: Iade_Iptal_S7_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s7_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_li3_desc(inputs)
	return tr_iade_iptal_s7_li3_desc(inputs)
});